import { configureStore } from '@reduxjs/toolkit';

import connectionReducer from './connection/connectionSlice';
import itemReducer from './item/itemSlice';
import helpersReducer from './helpers/helpersSlice';
import forecastReducer from './forecast/forecastSlice';
import adjustmentReducer from './adjustment/adjustmentSlice';
import autoformReducer from './autoform/autoformSlice';
import studiesReducer from './studies/studiesSlice';
import jobsReducer from './jobs/jobsSlice';
import navigationReducer from './navigation/navigationSlice';
import permissionsReducer from './permissions/permissionsSlice';
import powerBiReducer from './powerBi/powerBiSlice';
import featureFlagsReducer from './featureFlags/featureFlagsSlice';
import featureTogglesReducer from './featureToggles/featureTogglesSlice';
import itemCreationWizardReducer from './itemCreationWizard/itemCreationWizardSlice';
import { useDispatch } from 'react-redux';
import { wizardSlice } from 'components/wizard/store/wizardSlice';
import { portfolioSlice } from './portfolio/portfolioSlice';
import { mainMarketApi } from 'query/mainMarket';
import { bookApi } from 'query/books';

export const store = configureStore({
    reducer: {
        connections: connectionReducer,
        item: itemReducer,
        helpers: helpersReducer,
        forecast: forecastReducer,
        adjustment: adjustmentReducer,
        autoform: autoformReducer,
        studies: studiesReducer,
        jobs: jobsReducer,
        navigation: navigationReducer,
        permissions: permissionsReducer,
        powerBi: powerBiReducer,
        featureFlags: featureFlagsReducer,
        itemCreationWizard: itemCreationWizardReducer,
        featureToggles: featureTogglesReducer,
        wizard: wizardSlice.reducer,
        portfolio: portfolioSlice.reducer,

        // RTK Queries
        [mainMarketApi.reducerPath]: mainMarketApi.reducer,
        [bookApi.reducerPath]: bookApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mainMarketApi.middleware, bookApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
